<template>
	<div :class="classes" @click="close">
		<div :class="{ 'modal-wrap': !this.noModal }">
			<div :class="{ 'modal-wrap-inner': !this.noModal }">
				<div :class="{ 'modal-inner': !this.noModal, 'modal-inner-no-modal': this.noModal }" @click="stopClose">
					<h2 :class="{ 'modal-title': true, 'has-title': !!title||forceTitle, 'close-only': !title && !forceTitle }" v-if="!noModal && ( showClose || !!title || forceTitle )">
						{{ title ? title : "" }}
						<slot name="title" />
						<span class="close" @click="close" v-if="showClose">X</span>
					</h2>

					<div class="header" v-if="hasHeader"><slot name="header" /></div>

					<div :class="{ 'modal-inner-scroll': !this.noModal }">
						<slot name="content" />
					</div>

					<div class="footer-inner"><slot name="footer-inner" /></div>

					<Loading position="inner" v-if="loading" :noBackground="true" :text="loadingText" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Loading from "./../Loading.vue";
export default {
	name: "Modal",
	components: { Loading },
	props: {
		title: {
			type: String,
			default: "",
		},
		showClose: {
			type: Boolean,
			default: true,
		},
		size: {
			type: String,
			default: "small",
		},
		width: {
			type: Number,
		},
		full: {
			type: Boolean,
			default: false,
		},
		slider: {
			type: Boolean,
			default: false,
		},
		noScroll: {
			type: Boolean,
			default: false,
		},
		hasBaseButtons: {
			type: Boolean,
			default: true,
		},
		whiteOut: {
			type: Boolean,
			default: false,
		},
		scrollTop: {
			type: Number,
			default: 0,
		},
		scrollOnClose: {
			type: Boolean,
			default: true,
		},
		loading: {
			type: [String, Boolean],
			default: "",
		},
		hasHeader: {
			type: Boolean,
			default: false,
		},
		forceTitle: {
			type: Boolean,
			default: false,
		},
		noModal: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			top: 0,
		};
	},
	data() {
		return {
			closed: false,
		};
	},
	watch: {
		scrollTop() {
			const scrollableDivs = document.getElementsByClassName("modal-inner-scroll");
			Array.from(scrollableDivs).forEach(function(div) {
				div.scrollTop = 0;
			});
		},
	},
	computed: {
		loadingText() {
			if (!this.loading) return "";

			return typeof this.loading === "string" ? this.loading : "One moment...";
		},

		classes() {
			let classes = {
				modal: !this.noModal,
				"no-modal": this.noModal,
				'modal-component': true,
				[this.size]: true,
				full: this.full,
				"no-base-buttons": !this.hasBaseButtons,
				'no-default': !!this.full || !!this.width
			};

			if (this.width) {
				classes["width-" + this.width] = true;
				classes[this.size] = false;
			}

			if (this.noScroll) {
				classes["no-scroll"] = true;
			}

			classes["no-modal-title"] = !this.title && !this.forceTitle;

			if (this.slider) {
				classes["no-overlay2"] = true;
				classes["slider"] = true;
			}

			classes["white-out"] = !!this.loadingText;

			return classes;
		},
	},
	methods: {
		escHit(event) {
			if (event.key === "Escape") {
				this.close(event);
			}
		},

		clicked() {},
		closeBits() {
			document.body.classList.remove("modal-open");

			if (this.scrollOnClose) {
				setTimeout(
					function() {
						window.scrollTo(0, this.top);
					}.bind(this),
					1
				);
			}
		},
		close(event) {

			this.top = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);

			this.closed = true;

			event.stopPropagation();

			this.closeBits();

			this.$emit("close");
		},
		stopClose(event) {
			event.stopPropagation();
		},
	},
	created() {
		this.top = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);

		document.body.classList.add("modal-open");

		document.addEventListener("keydown", this.escHit);
	},
	beforeDestroy() {
		if (!this.closed) {
			this.closeBits();
		}
		document.removeEventListener("keydown", this.escHit);
	},
};
</script>
<style lang="less" scoped>
@import "./../../assets/css/less/_settings.less";
@import "./../../assets/css/less/_helper.less";
.modal-inner-no-modal {
	position: relative;
}
.modal,
.no-modal {
	.modal-wrap {
		&.transparent {
			.opacity(0);
		}

		.modal-inner {
			display: flex;
			flex-direction: column;
			padding: 0;
			max-height: calc(100vh - 40px);
			max-height: calc(100svh - 40px);

			.header,
			.footer-inner,
			.modal-title {
				flex: 0 0 auto;
			}

			.modal-inner-scroll {
				flex-grow: 1;
				min-height: 20px;
				max-height: 100%;
				z-index: 1;
				position: relative;
			}

			.modal-title {
				background: none;
				margin-bottom: 0;
				border-radius: 8px 8px 0 0;
				font-size: 24px;
				padding: 12px 65px 12px 20px;
				z-index: 2;

				&.close-only {
					padding: 0;
				}

				&.has-title {
					background-color: @darkContrast;
				}

				&:not(.has-title) {
					margin-bottom: 0;
					padding-bottom: 0;
					background: white;
					width: 100%;
					height: 20px;
				}

				.close {
					top: 13px;
				}
			}
		}
	}

	&.white-out {
		.modal-wrap {
			.modal-inner {
				background-color: #fff;
				> .header,
				> .footer-inner,
				> .modal-title,
				> .modal-inner-scroll {
					opacity: 0 !important;
				}
			}
		}
	}

	&.slider {
		max-width: 100vw;

		.modal-inner {
			padding-top: 15px;
		}
	}

	&.no-scroll {
		.modal-inner {
			overflow: visible;
			max-height: none;

			.modal-inner-scroll {
				overflow: visible;
				max-height: none;
			}
		}
	}

	&.width-400 {
		.modal-inner,
		.modal-inner-scroll {
			max-width: 400px !important;
		}
	}

	&.width-500 {
		.modal-inner,
		.modal-inner-scroll {
			max-width: 500px !important;
		}
	}

	&.width-600 {
		.modal-inner,
		.modal-inner-scroll {
			max-width: 600px !important;
		}
	}

	&.width-700 {
		.modal-inner,
		.modal-inner-scroll {
			max-width: 700px !important;
		}
	}

	&.width-800 {
		.modal-inner,
		.modal-inner-scroll {
			max-width: 800px !important;
		}
	}

	&.width-900 {
		.modal-inner,
		.modal-inner-scroll {
			max-width: 900px !important;
		}
	}

	&.width-1000 {
		.modal-inner,
		.modal-inner-scroll {
			max-width: 1000px !important;
		}
	}

	&.width-1200 {
		.modal-inner,
		.modal-inner-scroll {
			max-width: 1200px !important;
		}
	}

	&.width-1300 {
		.modal-inner,
		.modal-inner-scroll {
			max-width: 1300px !important;
		}
	}

	&.width-1400 {
		.modal-inner,
		.modal-inner-scroll {
			max-width: 1400px !important;
		}
	}

	&.width-1500 {
		.modal-inner,
		.modal-inner-scroll {
			max-width: 1500px !important;
		}
	}

	&.width-1600 {
		.modal-inner,
		.modal-inner-scroll {
			max-width: 1600px !important;
		}
	}

	&:not(.no-overlay) {
		.modal-inner-scroll {
			max-height: calc(100vh - 100px);
			padding: 20px;
		}

		&.full {
			.modal-inner {
				height: calc(100vh - 40px);
				height: calc(100svh - 40px);
				max-height: none;
			}

			&:not(.has-title) {
				.modal-inner-scroll {
					padding-top: 0px;
				}
			}

			&.no-base-buttons {
				.modal-inner-scroll {
					padding-top: 0;
					max-height: calc(100% - 20px);
				}
			}
		}

		&.small {
			.modal-inner,
			.modal-inner-scroll {
				max-width: 400px;
			}

			.modal-inner {
				.modal-title {
					margin-bottom: 20px;

					.close {
						width: 26px;
						height: 26px;
						top: 8px;
						right: 8px;
					}
				}
			}
		}
	}
}

.modal-component {
	&:not(.no-overlay) {
		> .modal-wrap {
			> .modal-wrap-inner {
				padding: 0;
			}
		}
	}

}

.no-modal {
	.modal-inner,
	.modal-inner-scroll,
	.modal-wrap {
		box-shadow: none;
		max-height: none;
		max-width: none;
		margin: 0;
		border-radius: 0;
		padding: 0 !important;
		.large-button {
			margin: 0;
		}
	}
	.modal-inner {
		form {
			label {
				padding: 0;
				line-height: 1em;
			}
		}
	}
}

@media (min-width: 540px) {
	.modal {
		&:not(.no-overlay) {
			&.full {
				.modal-wrap {
					padding-right: 90px;
				}
			}
		}
	}
}

@media (min-width: 768px) {
	.modal {
		&:not(.no-overlay) {
			&.full {
				.modal-wrap {
					padding-right: 20px;
				}
			}
		}
	}
}

@media screen and (min-width: 1024px) {
	.modal {
		&:not(.no-overlay) {
			&.full {
				.modal-wrap {
					padding-left: 20px;
				}
			}
		}
	}
}
</style>
